(function () {
    'use strict';

    angular
        .module('app')
        .controller('EmailSelectFromDialogCtrl', EmailSelectFromDialogCtrl);

    EmailSelectFromDialogCtrl.$inject = ['$q', '$scope', 'ChilliUserProfileService', 'EntitiesService', 'DialogInstance', 'fromAddressOverrideEntityId'];

    /**
     * @ngdoc Controller
     * @description
     * Dialog for selecting the emails from address
     *
     * @param {int} fromAddressOverrideEntityId - Id of the from addresss override entity
     *
     */
    function EmailSelectFromDialogCtrl($q, $scope, ChilliUserProfileService, EntitiesService, DialogInstance, fromAddressOverrideEntityId) {
        /* jshint validthis:true */
        var vm = this;
        vm.loading = true;
        vm.ok = close;
        vm.cancel = cancel;
        vm.title = 'Select Email From Address';
        vm.selectedEntityTemplate = null;
        vm.fromAddressOverrideEntityId = fromAddressOverrideEntityId;

        activate();

        function activate() {
            vm.loading = false;
        }

        function close() {
            var result = vm.fromAddressOverrideEntityId;
            if (_.isNil(vm.selectedEntityTemplate) || vm.selectedEntityTemplate === '') {
                result = null;
            }

            DialogInstance.ok(result);
        }

        function cancel() {
            DialogInstance.cancel();
        }
    }
})();
